import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserPhoneNumberService } from "Bands/services";
import { USER_ACTIONS } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IPhoneNumber, IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserPhoneNumbers = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserPhoneNumbers({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserPhoneNumbers,
    })
  );
};

const getUserPhoneNumbers = createAsyncThunk(
  USER_ACTIONS.getUserPhoneNumbers,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserPhoneNumberService.getUserPhoneNumbers({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userPhoneNumber]: data.userPhoneNumber,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserPhoneNumber = createAsyncThunk(
  USER_ACTIONS.createUserPhoneNumber,
  async (phoneNumber: IPhoneNumber, { rejectWithValue }) => {
    try {
      const data = await UserPhoneNumberService.createUserPhoneNumber(phoneNumber);
      const id = Object.values(data?.userPhoneNumber)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserPhoneNumber = createAsyncThunk(
  USER_ACTIONS.editUserPhoneNumber,
  async ({ id, data }: { id: string; data: Partial<IPhoneNumber> }, { rejectWithValue }) => {
    try {
      return await UserPhoneNumberService.editUserPhoneNumber(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserPhoneNumber = createAsyncThunk(
  USER_ACTIONS.deleteUserPhoneNumber,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserPhoneNumberService.deleteUserPhoneNumber(id);
      return {
        path: API_ENDPOINTS.USER_PHONE_NUMBER(id),
        dataKey: IDataKeys.userPhoneNumber,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
